import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {SiteConfigRule} from '../../models/site-config-rule';
import {SiteConfigParam} from '../../models/site-config-param';
import {Observable, Subscriber} from 'rxjs';
import {ConsentMode} from '../../types/consent-mode';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigRuleService extends AbstractModelService<SiteConfigRule> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/site-config-rule', SiteConfigRule);
  }

  changeParamState(id: number, siteConfigParam: SiteConfigParam, value: ConsentMode | boolean): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.put(this.routePath + '/' + id + '/param/' + siteConfigParam.key, {}, {value}).subscribe({
        next: () => {
          subscriber.next();
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
